import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Request } from 'components/Request';
import ExpandingTextarea from 'react/elements/ExpandingTextarea';

import PostGroupTopic from 'models/PostGroupTopic';
import PostTopic from 'react/posts/PostTopic';
import ActiveSelectableButton from '../elements/ActiveSelectableButton';
import PresetRepliesComponent from './PresetRepliesComponent';
import { getScrollParent } from '../../functions/getScrollParent';
import SpinningGear from "../elements/loaders/SpinningGear";

class PostManagerComponent extends Component {
	static propTypes = {
		inputKey: PropTypes.string.isRequired,
		inputValue: PropTypes.string.isRequired,
	};

	constructor(props) {
		super(props);
		const { postGroup, inputKey } = this.props;
		this.scrollParent = null;
		this.hasAttachedScrollbarEvent = false;
		this.state = {
			content: '',
			hoverContent: '',
			replying: false,
			topics: postGroup.topics,

			scrollbarVisible: false,

			isLoadingMore: false,
		};

		this.currentPage = 1;
		this.loadedAll = false;
		this.onContentChange = this.onContentChange.bind(this);
		this.wallPostsElement = React.createRef();

		this.isNotes = inputKey === 'player_to_player_note';

		this.usesQuickReply = !this.isNotes && this.props.usesQuickReply !== false;

		this.replyToPost = this.replyToPostWithUserText.bind(this);
		this.sendPostReply = this.sendPostReply.bind(this);
		this.sendPresetReply = this.sendPresetReply.bind(this);
		this.windowScroll = this.windowScroll.bind(this);
		this.loadMore = this.loadMore.bind(this);
	}

	windowScroll() {
		const element = $(this.wallPostsElement.current);
		if(!element.length || !element.is(':visible')) {
			return;
		}
		var assetAreaBottom = element.position().top + element.innerHeight();
		var windowBottom = $(window).scrollTop() + $(window).innerHeight();

		if(windowBottom + 120 >= assetAreaBottom) {
			this.loadMore();
		}
	}

	loadMore() {

		const { topics } = this.state;
		if(this.loadedAll || this.state.isLoadingMore) {
			return;
		}
		const lastPost = topics.length && topics[topics.length - 1];

		const data = {};
		data.last_loaded_post = lastPost.id;
		this.setState({
			isLoadingMore: true
		});
		this.checkScrollbarVisibility();
		Request.get(siteUrl + '/posts/load_more', data).then((response) => {
			if(response.posts && response.posts.length) {
				console.log('what is posts', response.posts);

				this.setState((state) => {
					const topics = [...state.topics];
					_.each(response.posts, (replyData) => {
						topics.push(PostGroupTopic.create(replyData));
					});
					return {
						content: '',
						topics,
					};
				});
			}
			else {
				this.loadedAll = true;
			}
		}).finally(() => {
			this.setState({
				isLoadingMore: false
			});
		});
	}

	componentWillUnmount() {
		if(this.hasAttachedScrollbarEvent && this.scrollParent) {
			this.scrollParent.removeEventListener('scroll', this.windowScroll);
		}
	}

	componentDidMount() {
		this.checkScrollbarVisibility();
	}

	checkScrollbarVisibility() {
		this.scrollParent = getScrollParent(this.wallPostsElement.current);
		const scrollbarIsVisible = this.scrollParent.scrollHeight > this.scrollParent.clientHeight;

		if(!this.hasAttachedScrollbarEvent) {
			this.scrollParent.addEventListener('scroll', this.windowScroll);
		}
		this.setState({ scrollbarVisible: scrollbarIsVisible });
	}

	sendPresetReply(text) {
		return this.sendPostReply(text);
	}

	replyToPostWithUserText() {
		const { content } = this.state;
		return this.sendPostReply(content);
	}

	sendPostReply(text) {
		const { inputKey, inputValue } = this.props;
		this.setState({
			replying: true
		});
		const submission = {};

		submission[inputKey] = inputValue;
		submission.message = text;

		console.log('the text', text);

		Request.post(siteUrl + '/posts/submit_post_reply', submission).then((response) => {
			this.setState((state) => {
				const topics = [...state.topics];
				topics.unshift(PostGroupTopic.create(response.reply));
				return {
					content: '',
					topics,
				};
			});

		}).finally(() => {
			this.setState({
				replying: false
			});
		});
	}

	onContentChange(e) {
		this.setState({ content: e.target.value });
	}

	render() {
		const { postGroup, inputKey } = this.props;
		const { content, hoverContent, topics, replying, isLoadingMore, scrollbarVisible } = this.state;

		const newMessagePlaceholder = this.isNotes ? 'Add a Note' : 'Add a new post!';

		return (
			<React.Fragment>
				<div className='panel group-wall'>
					<div className='reply_to_post'>
						<ExpandingTextarea
							className='wall_post_content materialize-textarea'
							name='message'
							onChange={this.onContentChange}
							placeholder={newMessagePlaceholder}
							disabled={replying}
							value={hoverContent ? hoverContent : content}
						/>
						<footer className='panel-body row'>
							<div className='col-xs-4'>
								<ActiveSelectableButton
									type='submit'
									onClick={this.replyToPost}
									className={`add_post_button ${replying ? 'disabled' : ''}`}>
									Post
								</ActiveSelectableButton>
							</div>

							{myUser.is_ladder_mod && this.usesQuickReply &&
							<div className='col-xs-8'>
								<PresetRepliesComponent
									sendPostReply={this.sendPostReply}
								/>
							</div>
							}
						</footer>
					</div>
				</div>
				<div className='wall_post_display'>
					<div ref={this.wallPostsElement} className='wall_posts fb-comments'>
						{topics.map((topic) => (
							<PostTopic
								key={topic.id}
								topic={topic}
								isNotes={this.isNotes}
							/>
						))}

						{!this.loadedAll && !scrollbarVisible &&
						<div>
							<ActiveSelectableButton
								disabled={isLoadingMore}
								onClick={this.loadMore}
							>
								Load More {isLoadingMore && <SpinningGear />}
							</ActiveSelectableButton>
						</div>
						}
					</div>
				</div>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {
		...state.matchmaking,
	};
}

export default connect(
	mapStateToProps,
)(PostManagerComponent);